import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-schedule',
  templateUrl: './cyclops-schedule.component.html',
  styleUrls: ['./cyclops-schedule.component.scss']
})
export class cyclopsScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  


}
